module.exports = __webpack_public_path__ + "static/img/sryx.ba9868e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/kpi/sryx.png
// module id = 2l0y
// module chunks = 4